<template>
    <modal @close="emit('close')" id="modalChartBookTemplate">
        <template #header>
            Add to Chart Book
        </template>
        <template #body>
            <div class="flex flex-wrap py-2 pb-3">
                <div class="w-full p-0 mt-2">
                    <label for="symbol-display">
                        Symbol
                        <input id="symbol-display" disabled="disabled" type="text" class="form-control form-control form-input-sm-inline" name="symbol_display" v-model="form.symbol_display" />
                    </label>
                </div>
                <div class="w-full p-0 mt-2">
                    <label for="chart-title">
                        Chart Title
                        <input id="chart-title" autocomplete="off" type="text" :class="{'is-invalid': form.errors.title}" class="form-control form-control form-input-sm-inline" name="title" v-model="form.title"  placeholder="Enter a short description" />
                    </label>
                    <div class="error" v-if="form.errors.title">{{ form.errors.title }}</div>
                </div>
                <div class="w-full p-0 mt-2">
                    <label for="chart-book">
                        Chart Book
                        <select class="form-control form-control-sm" v-model="form.chartbookId" :class="{'is-invalid': form.errors.chartbook}" id="chart-book">
                            <option value="0">Select one</option>
                            <option :value="chartbook.id" v-for="chartbook in chartBooks">{{ chartbook.name }}</option>
                            <option value="new">Add a new Chart Book</option>
                        </select>
                    </label>

                    <div v-if="form.chartbookId === 'new'" class="w-full p-0 mt-2">
                        <label for="chart-book-name">Chart Book Name:</label>
                        <input class="form-control form-control form-input-sm-inline" type="text" name="chart-book-name" v-model="form.name">
                        <div class="error" v-if="form.errors.name">{{ form.errors.name }}</div>
                    </div>

                    <div class="error" v-if="form.errors.chartbook">{{ form.errors.chartbook }}</div>
                </div>
                <div v-if="isJim()" class="w-full p-0 mt-2">
                    <label for="make-public">Make Public</label>
                    <input id="make-public" :value="true" v-model="form.public" type="checkbox" name="">
                </div>
            </div>
        </template>

        <template #footer>
            <div class="flex justify-center">
                <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1" @click="emit('close')">Cancel</div>
                <div class="btn btn-sm btn-yellow inline-flex mx-1" @click="saveToChartBook">Add</div>
            </div>
        </template>
    </modal>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useIsJim } from '../../mixins/IsJim';

const props = defineProps({
    symbolDisplay: String,
    chartBooks: Array
});

const emit = defineEmits(['saved', 'close']);
const { isJim } = useIsJim();

const form = ref({
    chartbookId: getLastChartBookSavedTo() || '0',
    symbol_display: props.symbolDisplay,
    title: '',
    name: '',
    // Only used for Jim
    public: false,
    errors: {
        title: '',
        chartbook: '',
        name: '',
    },
    default: true
});

const validate = () => {
    let valid = true;

    if (form.value.title.length === 0) {
        valid = false;
        form.value.errors.title = 'Please enter a chart title';
    }

    if (!form.value.chartbookId || form.value.chartbookId === '0') {
        valid = false;
        form.value.errors.chartbook = 'Please select a chartbook';
    }

    if (form.value.chartbookId === 'new' && form.value.name === '') {
        valid = false;
        form.value.errors.name = 'Please enter a chart book name';
    }

    return valid;
};

function getLastChartBookSavedTo() {
    const lastSavedFromStorage = window.localStorage.getItem('lastChartBookSavedTo');
    if (lastSavedFromStorage) {
        const found = props.chartBooks.find(c => c.id === parseInt(lastSavedFromStorage) );

        if (found) {
            return lastSavedFromStorage;
        }
    }
}

const saveToChartBook = () => {
    if (!validate()) return;
    window.localStorage.setItem('lastChartBookSavedTo', form.value.chartbookId);
    emit('saved', form.value);
    emit('close');
};
</script>
